module.exports = __webpack_public_path__ + "img/icon_crm_home.8b9de73c.svg";